import { HelpTooltip } from '../ui/HelpTooltip'

export function ConceptTypeTooltip() {
	return (
		<HelpTooltip title="Concept Types" ariaLabel="Concept type help">
			<div>
				<div className="help-tooltip-item-title">
					Motion
				</div>
				<p className="help-tooltip-item-description">
					Pre-snap player movement that occurs before the ball is snapped. Motion paths are
					displayed as dotted lines and animate before routes execute.
				</p>
				<div className="help-tooltip-example">
					<span className="help-tooltip-example-text">
						Examples: Jet, Orbit, Return
					</span>
				</div>
			</div>

			<div>
				<div className="help-tooltip-item-title">
					Modifier
				</div>
				<p className="help-tooltip-item-description">
					Adjusts player positions within an existing formation. Modifiers move players closer or
					farther from the formation center.
				</p>
				<div className="help-tooltip-example">
					<span className="help-tooltip-example-text">
						Examples: Tight, Nasty, Wide
					</span>
				</div>
			</div>

			<div className="help-tooltip-note">
				<p className="help-tooltip-note-text">
					Note: A concept can be either Motion or Modifier, but not both.
				</p>
			</div>
		</HelpTooltip>
	)
}
